var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modal)?_c('div',{staticClass:"Modal",on:{"click":function($event){return _vm.closeModal($event)}}},[_c('div',{staticClass:"ModalContent",style:({ 'max-width': _vm.isWidth ? `${_vm.isWidth}px` : '750px' })},[_vm._t("header"),_vm._t("content"),_vm._t("footer")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }